var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRating(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2152 8.7771C20.1515 8.57161 19.9821 8.42185 19.7782 8.39082L14.0493 7.51811L11.4872 2.07612C11.396 1.8824 11.2078 1.75977 11.0017 1.75977C10.7957 1.75977 10.6075 1.8824 10.5163 2.07612L7.95404 7.51811L2.22526 8.39082C2.02137 8.42185 1.85191 8.57161 1.78824 8.77706C1.72454 8.98256 1.77767 9.2081 1.92525 9.35889L6.07053 13.5949L5.09211 19.5763C5.05724 19.7892 5.14076 20.0044 5.30748 20.1314C5.40179 20.2032 5.5135 20.2398 5.62575 20.2398C5.71194 20.2398 5.79842 20.2182 5.87761 20.1746L11.0017 17.3505L16.1256 20.1745C16.308 20.2751 16.529 20.2583 16.6958 20.1314C16.8625 20.0044 16.946 19.7892 16.9112 19.5762L15.9325 13.5949L20.0782 9.35885C20.2258 9.2081 20.2789 8.98256 20.2152 8.7771Z",
    fill: "#0741AD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRating);
export default __webpack_public_path__ + "static/media/Rating.20ea4b28.svg";
export { ForwardRef as ReactComponent };